export function useUserMetadata<T>(key: MaybeRefOrGetter<string>) {
  const api = useApiClients()

  const url = computed(() => `/rest/frontend/metadata/${toValue(key)}`)
  return {
    async get() {
      try {
        const res = await api.external<{ value: string }>(url.value)

        return JSON.parse(res.value) as T
      } catch (error) {
        if (!isNotFound(error)) {
          captureException(error)
        }

        return undefined
      }
    },

    async set(value: T | null, userId?: string) {
      if (!userId)
        return
      try {
        await api.external(url.value, {
          method: "PUT",
          body: {
            userId,
            key: toValue(key),
            value: JSON.stringify(value),
          },
        })
      } catch (error) {
        captureException(error)
      }
    },
  }
}
